export const NAV_DRAWER_WIDTH = 256;
export const APP_BAR_HEIGHT = 56;
export const DT_PAGE_SIZE = 15;

const affiliateStatus = {
  DELETED: 0,
  0: 'Deleted',
  PENDING: 1,
  1: 'Pending',
  APPROVED: 2,
  2: 'Approved',
  DISAPPROVED: 3,
  3: 'Disapproved',
};

const userRoles = {
  CUSTOMER: 0,
  0: 'Customer',
  AFFILIATE: 1,
  1: 'Affiliate',
  CUSTOMERAFFILIATE: 3,
  3: 'Customer+Affiliate',
};

const pickupStatus = {
  NA: 0,
  0: 'N/A',
  REZGO_UNCONFIRMED: 1,
  1: 'Rezgo Booking Unconfirmed',
  OTHER_HOTEL: 2,
  2: 'Other Hotel',
  CONFIRMED: 3,
  3: 'Confirmed',
};

const COLLECTIONS = {
  AFFILIATES: 'refferer',
  BOOKINGS: 'bookings',
  CREATED_PROMOCODES: 'promocodes_created',
  TO_BE_CREATED_PROMOCODES: 'promocodes_to_create',
  USERS: 'Users',
  BLOGS: 'blogs',
  EXCURSIONS: 'rezgoInventoryData',
  HOTEL_PICKUPS: 'pickup_info',
};

const BackendServer = {
  baseURL: process.env.REACT_APP_BACKEND_SERVER,
  OAuth: process.env.REACT_APP_BACKEND_SERVER,
  clientID: process.env.OAUTH,
};

const blogStatus = {
  DELETED: 0,
  0: 'Deleted',
  DRAFT: 1,
  1: 'Draft',
  PUBLISHED: 2,
  2: 'Published',
};

export { affiliateStatus, COLLECTIONS, BackendServer, userRoles, pickupStatus, blogStatus };
